import * as tslib_1 from "tslib";
import { CacheKey } from '../constants/cachekey.constants';
import { Portals } from 'src/app/common/enums/portal.enum';
export class AuthService {
    constructor(_cacheService, _storePortalService, _storePortalFeatureService) {
        this._cacheService = _cacheService;
        this._storePortalService = _storePortalService;
        this._storePortalFeatureService = _storePortalFeatureService;
        this._privilegesLoaded = false;
        this._storePortalsLoaded = false;
        /**
         * Validate the store access levels
         */
        this.hasSuperUserAccess = () => {
            return new Promise((resolve, reject) => {
                this.hasAccessToPortal(Portals.All)
                    .then((res) => {
                    resolve(res);
                })
                    .catch((err) => {
                    reject(false);
                });
            });
        };
        /**
         * Load Store Portals Information
         */
        this.loadStorePortals = () => tslib_1.__awaiter(this, void 0, void 0, function* () {
            const store = this._cacheService.get(CacheKey.StoreConfiguration);
            if (store !== undefined && store !== null) {
                if (store.portals !== undefined
                    && store.portals !== null && store.portals.length > 0) {
                    this._storePortals = store.portals;
                }
                else {
                    yield this._storePortalService.getStorePortals(store.id).then(res => {
                        this._storePortals = res;
                    });
                }
            }
        });
    }
    /**
     * Initialize the store features
     */
    init() {
        return tslib_1.__awaiter(this, void 0, void 0, function* () {
            return this.fillInPrivileges();
        });
    }
    /**
     * Validate whether the feature is enabled or not
     * @param privilegeNames
     * @param privilegeType
     */
    hasPrivilege(privilegeNames, privilegeType) {
        return tslib_1.__awaiter(this, void 0, void 0, function* () {
            const promise = new Promise((resolve, reject) => {
                this.hasSuperUserAccess()
                    .then((res) => tslib_1.__awaiter(this, void 0, void 0, function* () {
                    if (res) {
                        resolve(res);
                    }
                    else {
                        if (privilegeNames === null || privilegeNames === undefined
                            || privilegeNames.length === 0) {
                            resolve(true);
                        }
                        yield this.validatePrivileges(privilegeNames)
                            .then((res) => {
                            resolve(res);
                        });
                    }
                })).
                    catch(err => {
                    resolve(true);
                });
            });
            return promise;
        });
    }
    /**
     * Validate Privileges
     * @param privilegeNames
     */
    validatePrivileges(privilegeNames) {
        return tslib_1.__awaiter(this, void 0, void 0, function* () {
            return new Promise((resolve) => {
                let hasPrivilege = this.hasRequiredPrivilege(privilegeNames);
                resolve(hasPrivilege);
            });
        });
    }
    /**
     * validate privilege existance
     * @param privilegeNames
     */
    hasRequiredPrivilege(privilegeNames) {
        if (this._privileges) {
            for (const privilege of privilegeNames) {
                let exists = (this._privileges.filter(x => x.code.toLowerCase()
                    == privilege.toLowerCase()).length > 0) ? true : false;
                if (exists) {
                    return exists;
                }
            }
            return false;
        }
        else {
            return true;
        }
    }
    /**
     * Initialize the privileges
     */
    initializePrivileges() {
        return tslib_1.__awaiter(this, void 0, void 0, function* () {
            return new Promise((resolve, reject) => tslib_1.__awaiter(this, void 0, void 0, function* () {
                if ((this._privileges === undefined || this._privileges === null)) {
                    let privileges = this._cacheService.get(CacheKey.Store_Portal_Features);
                    if ((privileges === undefined || privileges === null) && !this._privilegesLoaded) {
                        const store = this._cacheService.get(CacheKey.StoreConfiguration);
                        if (store && store.id) {
                            yield this._storePortalFeatureService.getStorePortalFeatures(store.id, Portals.Corporate)
                                .then(res => {
                                this._privileges = res;
                                this._privilegesLoaded = true;
                            });
                            resolve(true);
                        }
                        else {
                            reject(false);
                        }
                    }
                    else {
                        this._privileges = privileges;
                        this._privilegesLoaded = true;
                        resolve(true);
                    }
                }
                else {
                    resolve(true);
                }
            }));
        });
    }
    /**
     * Check and load privileges
     */
    fillInPrivileges() {
        return tslib_1.__awaiter(this, void 0, void 0, function* () {
            yield this.hasSuperUserAccess()
                .then(res => {
                if (!res) {
                    return this.initializePrivileges();
                }
            })
                .catch(err => {
                return this.initializePrivileges();
            });
        });
    }
    /**
     * Check the Portal mapping for a given portal id in store
     * @param portalId
     */
    hasAccessToPortal(portalId) {
        return tslib_1.__awaiter(this, void 0, void 0, function* () {
            let hasAccess = true;
            if ((this._storePortals === undefined || this._storePortals === null) && !this._storePortalsLoaded) {
                yield this.loadStorePortals();
                this._storePortalsLoaded = true;
            }
            if (this._storePortals !== undefined
                && this._storePortals !== null && this._storePortals.length > 0) {
                hasAccess = (this._storePortals.findIndex(m => m.id === Portals.All) == -1 ? false : true);
                if (!hasAccess && portalId > 0) {
                    hasAccess = this._storePortals.findIndex(m => m.id === portalId) === -1 ? false : true;
                }
            }
            return hasAccess;
        });
    }
}
